var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 170,
        width: 580,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [_c("rect", { attrs: { height: "160", width: "565", y: "5", x: "7.5" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }